import { AccessibleIcon } from '@radix-ui/react-accessible-icon'
import React, { SVGProps } from 'react'

interface Alert extends SVGProps<SVGSVGElement> {
  label?: string
}

const Alert: React.FC<Alert> = ({ label = 'alert', ...restProps }) => {
  return (
    <AccessibleIcon label={label}>
      <svg
        {...restProps}
        data-testid="alert-svg"
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.7938 2.75004L20.526 17.875C20.6065 18.0144 20.6488 18.1725 20.6488 18.3334C20.6488 18.4943 20.6065 18.6523 20.526 18.7917C20.4456 18.931 20.3298 19.0468 20.1905 19.1272C20.0511 19.2077 19.8931 19.25 19.7322 19.25H2.26784C2.10693 19.25 1.94886 19.2077 1.80951 19.1272C1.67017 19.0468 1.55445 18.931 1.474 18.7917C1.39355 18.6523 1.3512 18.4943 1.3512 18.3334C1.3512 18.1725 1.39355 18.0144 1.47401 17.875L10.2062 2.75004C10.2866 2.6107 10.4023 2.49499 10.5417 2.41455C10.681 2.3341 10.8391 2.29175 11 2.29175C11.1609 2.29175 11.319 2.3341 11.4583 2.41455C11.5977 2.49499 11.7134 2.6107 11.7938 2.75004ZM10.0833 14.6667V16.5H11.9167V14.6667H10.0833ZM10.0833 8.25004V12.8334H11.9167V8.25004H10.0833Z"
          fill="currentColor"
        />
      </svg>
    </AccessibleIcon>
  )
}

export default Alert
